import React, { Component } from "react";
import logo from "./logo.svg";
import {typography} from './utils/typography'
import { Dashboard } from "./dc/dashboard";
//import { Welcome } from "./welcome";
import { Grid } from "react-flexbox-grid";
import { css } from "glamor";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faSync } from '@fortawesome/free-solid-svg-icons'

library.add(fab, faSync)

class App extends Component {

  render() {
    const style = css({
      background: `#fff`

    })
    typography.injectStyles()
    return (
      <div {...style}>
        <Grid>
          <Dashboard />
        </Grid>
      </div>
    );
  }
}

export default App;
